import axios from "axios";
import * as APPCONFIG from "../config/app-config.js";
import { decryptData, encryptData } from "../Custom/Custom.js";

const axiosApi = axios.create({
  headers: APPCONFIG.HTTP_HEADERS,
  baseURL: APPCONFIG.API_URL,
});

// axiosApi.interceptors.request.use(
//   function (config) {
//     try {
//       if (config.data) {
//         // Encrypt the payload
//         const encrypted = encryptData(config.data);

//         // Backend expects encrypted data in { data: "<cipher>" }
//         config.data = { data: encrypted };
//       }
//     } catch (err) {
//       console.error("Encryption failed in interceptor:", err);
//     }

//     return config;
//   },
//   function (error) {
//     return Promise.reject(error);
//   }
// );

axiosApi.interceptors.response.use(
  function (response) {
    try {
      if (response.data && typeof response.data.data === "string") {
        const decrypted = decryptData(response.data.data);
        response.data.data = decrypted;
      }
    } catch (err) {
      console.error("Decryption failed in interceptor:", err);
    }

    return response;
  },
  function (error) {
    switch (error.response.status) {
      case 503:
        break;
      default:
        break;
    }
    return Promise.reject(error);
  }
);

export default axiosApi;
